"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileboyClient = void 0;
var jose_1 = require("jose");
var error_box_1 = require("@cd2/error-box");
var constants_1 = require("./constants");
var errors_1 = require("./errors");
var utils_1 = require("./utils");
var FileboyClient = /** @class */ (function () {
    function FileboyClient(opts) {
        this.publicKey = opts.publicKey;
        this.apiUrl = opts.apiUrl || constants_1.API_URL;
        this.accessTokens = {};
        this.fetchMethod = opts.fetchMethod || utils_1.defaultFetchMethod;
    }
    FileboyClient.prototype.getAccessToken = function (givenToken, id) {
        if (givenToken) {
            return givenToken;
        }
        if (id && this.accessTokens[id]) {
            if (this.accessTokens[id].expiry > Date.now() + 10 * 1000) {
                return this.accessTokens[id].accessToken;
            }
            else {
                delete this.accessTokens[id];
            }
        }
    };
    FileboyClient.prototype.handleErrorResponse = function (response) {
        var error = response.error;
        if (typeof error === "object") {
            return error_box_1.ErrorBox.fromJson(response.error);
        }
        else {
            var message = response.message || String(response.error);
            return new Error(message);
        }
    };
    FileboyClient.prototype.buildFileUrl = function (idOrLabelOrOptions, options) {
        var mergedOptions;
        if (typeof idOrLabelOrOptions === "string") {
            var idOrLabel = idOrLabelOrOptions.includes("-")
                ? { id: idOrLabelOrOptions }
                : { label: idOrLabelOrOptions };
            mergedOptions = __assign(__assign({}, (options !== null && options !== void 0 ? options : {})), idOrLabel);
        }
        else {
            mergedOptions = idOrLabelOrOptions;
        }
        if (!mergedOptions.id && !mergedOptions.label) {
            throw (0, errors_1.applicationError)("No id given");
        }
        var id = mergedOptions.id ? mergedOptions.id : "".concat(this.publicKey, "+").concat(mergedOptions.label);
        var fullUrl = "".concat(this.apiUrl, "/files/get/").concat(id);
        if (mergedOptions.filename !== undefined) {
            fullUrl += "/".concat(encodeURIComponent(mergedOptions.filename));
        }
        var query = false;
        if (mergedOptions.accessToken) {
            fullUrl += query ? "&" : "?";
            fullUrl += "authorization=" + encodeURIComponent(mergedOptions.accessToken);
            query = true;
        }
        if (mergedOptions.download) {
            fullUrl += query ? "&" : "?";
            fullUrl += "download";
            query = true;
        }
        return fullUrl;
    };
    FileboyClient.prototype.buildImageUrl = function (idOrLabelOrOptions, options) {
        var mergedOptions;
        if (typeof idOrLabelOrOptions === "string") {
            var idOrLabel = idOrLabelOrOptions.includes("-")
                ? { id: idOrLabelOrOptions }
                : { label: idOrLabelOrOptions };
            mergedOptions = __assign(__assign({}, (options !== null && options !== void 0 ? options : {})), idOrLabel);
        }
        else {
            mergedOptions = idOrLabelOrOptions;
        }
        if (!mergedOptions.id && !mergedOptions.label) {
            throw (0, errors_1.applicationError)("No id given");
        }
        var id = mergedOptions.id ? mergedOptions.id : "".concat(this.publicKey, "+").concat(mergedOptions.label);
        var fullUrl = "".concat(this.apiUrl, "/images/get/").concat(id);
        if (mergedOptions.filename !== undefined) {
            fullUrl += "/".concat(encodeURIComponent(mergedOptions.filename));
        }
        var query = false;
        if (mergedOptions.transforms) {
            var transformsStrings = mergedOptions.transforms.map(function (transform) {
                var _a, _b;
                var value = "";
                if (transform.type === "invert") {
                    // invert is fine
                }
                else if (transform.type === "background") {
                    value = parseColor(transform.color);
                }
                else if (transform.type === "blur") {
                    value = String(transform.amount);
                }
                else if (transform.type === "flip") {
                    value = transform.direction;
                }
                else if (transform.type === "format") {
                    value = transform.format;
                }
                else if (transform.type === "quality") {
                    value = String(transform.value);
                }
                else if (transform.type === "saturate") {
                    value = String(transform.amount);
                }
                else if (transform.type === "resize") {
                    value = "".concat((_a = transform.width) !== null && _a !== void 0 ? _a : "_", "x").concat((_b = transform.height) !== null && _b !== void 0 ? _b : "_");
                    if (transform.position) {
                        value += "~position:".concat(transform.position);
                    }
                    if (transform.fit) {
                        value += "~fit:".concat(transform.fit);
                    }
                    if (transform.background) {
                        value += "~background:".concat(parseColor(transform.background));
                    }
                }
                else if (transform.type === "resizeAR") {
                    value = "".concat(transform.ratio[0], "x").concat(transform.ratio[1]);
                    if (transform.position) {
                        value += "~position:".concat(transform.position);
                    }
                    if (transform.fit) {
                        value += "~fit:".concat(transform.fit);
                    }
                    if (transform.background) {
                        value += "~background:".concat(parseColor(transform.background));
                    }
                }
                else if (transform.type === "crop") {
                    var width = transform.width, height = transform.height, top_1 = transform.top, left = transform.left;
                    value = "".concat(width, "x").concat(height);
                    if (top_1 !== undefined || left !== undefined) {
                        var leftStr = typeof left === "number" ? String(left) : left === undefined ? "50pc" : "".concat(left.pc, "pc");
                        var topStr = typeof top_1 === "number" ? String(top_1) : top_1 === undefined ? "50pc" : "".concat(top_1.pc, "pc");
                        value += "@".concat(leftStr, ",").concat(topStr);
                    }
                }
                else if (transform.type === "rotate") {
                    value = String(transform.angle);
                    if (transform.background) {
                        value += "~background:".concat(parseColor(transform.background));
                    }
                }
                else if (transform.type === "tint") {
                    value = parseColor(transform.color);
                }
                else if (transform.type === "smartCrop") {
                    value = "".concat(transform.width, "x").concat(transform.height);
                }
                else {
                    // @ts-expect-error
                    throw (0, errors_1.applicationError)("Unknown transform ".concat(transform.type));
                }
                var fullString = value ? "".concat(transform.type, ":").concat(value) : transform.type;
                return fullString;
            });
            var transformQueryString = transformsStrings.join(";");
            if (transformQueryString) {
                fullUrl += query ? "&" : "?";
                fullUrl += "transform=".concat(transformQueryString);
                query = true;
            }
        }
        else if (mergedOptions.rawTransformString) {
            fullUrl += query ? "&" : "?";
            fullUrl += "transform=".concat(mergedOptions.rawTransformString);
            query = true;
        }
        if (mergedOptions.accessToken) {
            fullUrl += query ? "&" : "?";
            fullUrl += "authorization=" + encodeURIComponent(mergedOptions.accessToken);
            query = true;
        }
        if (mergedOptions.download) {
            fullUrl += query ? "&" : "?";
            fullUrl += "download";
            query = true;
        }
        return fullUrl;
    };
    /**
     * Fetch information about a file.
     *
     * @param id - The id of the file to fetch.
     * @returns Details of the file.
     */
    FileboyClient.prototype.getFileData = function (id_1) {
        return __awaiter(this, arguments, void 0, function (id, options) {
            var accessToken, headers, _a, _status, response;
            if (options === void 0) { options = {}; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!id) {
                            throw (0, errors_1.applicationError)("No id given");
                        }
                        if (!id.includes("-")) {
                            id = "".concat(this.publicKey, "+").concat(id);
                        }
                        accessToken = this.getAccessToken(options.accessToken, id);
                        headers = {
                            authorization: accessToken ? "token ".concat(accessToken) : "public ".concat(this.publicKey),
                        };
                        return [4 /*yield*/, this.fetchMethod({
                                url: "".concat(this.apiUrl, "/files/data/").concat(id),
                                method: "GET",
                                headers: headers,
                            })];
                    case 1:
                        _a = _b.sent(), _status = _a[0], response = _a[1];
                        if ("error" in response) {
                            throw this.handleErrorResponse(response);
                        }
                        else {
                            return [2 /*return*/, response.data];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch a filtered list of files, either by their SHA1 hash or their metadata content.
     *
     * @param filter - What to search by, either:
     *  - A partial set of metadata. Values are matched case-insensitively, meaning `{ name: "john" }` would match a record with `{ name: "John Smith" }`.
     *  - The SHA1 hash of the file's data.
     * @returns Details of the files matching the filter (up to 100).
     */
    FileboyClient.prototype.searchFileData = function (filter_1) {
        return __awaiter(this, arguments, void 0, function (filter, options) {
            var accessToken, headers, query, _a, _status, response;
            if (options === void 0) { options = {}; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        accessToken = this.getAccessToken(options.accessToken);
                        headers = {
                            authorization: accessToken ? "token ".concat(accessToken) : "public ".concat(this.publicKey),
                        };
                        query = "hash" in filter
                            ? "hash=".concat(encodeURIComponent(filter.hash))
                            : "metadata=".concat(encodeURIComponent(JSON.stringify(filter.metadata)));
                        return [4 /*yield*/, this.fetchMethod({
                                url: "".concat(this.apiUrl, "/files?").concat(query),
                                method: "GET",
                                headers: headers,
                            })];
                    case 1:
                        _a = _b.sent(), _status = _a[0], response = _a[1];
                        if ("error" in response) {
                            throw this.handleErrorResponse(response);
                        }
                        else {
                            return [2 /*return*/, response.data];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Upload a new file.
     *
     * @param file - The File object to be uploaded.
     * @param options - Specify additional data to saved with the file.
     * @returns Data about the newly-created file.
     */
    FileboyClient.prototype.uploadFile = function (file_1) {
        return __awaiter(this, arguments, void 0, function (file, options) {
            var formData, accessToken, headers, _a, _status, response, data, accessToken_1, token;
            if (options === void 0) { options = {}; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        formData = new FormData();
                        formData.set("file", file);
                        formData.set("data", JSON.stringify(options));
                        accessToken = this.getAccessToken(options.accessToken);
                        headers = {
                            authorization: accessToken ? "token ".concat(accessToken) : "public ".concat(this.publicKey),
                        };
                        return [4 /*yield*/, this.fetchMethod({
                                url: "".concat(this.apiUrl, "/files/upload"),
                                method: "POST",
                                headers: headers,
                                body: formData,
                            })];
                    case 1:
                        _a = _b.sent(), _status = _a[0], response = _a[1];
                        if ("error" in response) {
                            throw this.handleErrorResponse(response);
                        }
                        else {
                            data = response.data, accessToken_1 = response.accessToken;
                            if (accessToken_1) {
                                token = (0, jose_1.decodeJwt)(accessToken_1.split("$")[2]);
                                this.accessTokens[data.id] = { accessToken: accessToken_1, expiry: token.exp * 1000 };
                            }
                            return [2 /*return*/, data];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Upload a new file from a remote URL.
     *
     * @param url - The URL at which to find the file data.
     * @param options - Specify additional options for the upload.
     * @returns Data about the newly-created file.
     */
    FileboyClient.prototype.uploadFileFromUrl = function (url_1) {
        return __awaiter(this, arguments, void 0, function (url, options) {
            var expect, data, accessToken, headers, _a, _status, response, data_1, accessToken_2, token;
            if (options === void 0) { options = {}; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        expect = options.expect, data = __rest(options, ["expect"]);
                        accessToken = this.getAccessToken(options.accessToken);
                        headers = {
                            authorization: accessToken ? "token ".concat(accessToken) : "public ".concat(this.publicKey),
                            "Content-type": "application/json",
                        };
                        return [4 /*yield*/, this.fetchMethod({
                                url: "".concat(this.apiUrl, "/files/upload"),
                                method: "POST",
                                headers: headers,
                                body: JSON.stringify({ url: url, expect: expect, data: data }),
                            })];
                    case 1:
                        _a = _b.sent(), _status = _a[0], response = _a[1];
                        if ("error" in response) {
                            throw this.handleErrorResponse(response);
                        }
                        else {
                            data_1 = response.data, accessToken_2 = response.accessToken;
                            if (accessToken_2) {
                                token = (0, jose_1.decodeJwt)(accessToken_2.split("$")[2]);
                                this.accessTokens[data_1.id] = { accessToken: accessToken_2, expiry: token.exp * 1000 };
                            }
                            return [2 /*return*/, data_1];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return FileboyClient;
}());
exports.FileboyClient = FileboyClient;
function parseColor(color) {
    if (/#([0-9A-F]{3}|[0-9A-F]{6}|[0-9A-F]{8})/i.test(color)) {
        return "hex(".concat(color.replace("#", ""), ")");
    }
    else {
        return color;
    }
}
